import {createStyles} from '@material-ui/core/styles';
import {Fonts} from '../../../../shared/constants/AppEnums';

const useStyles = (theme) =>
  createStyles({
    navItem: {
      height: 44,
      marginTop: 2,
      marginBottom: 2,
      width: 'calc(100% - 16px)',
      paddingLeft:
        theme.direction === 'ltr' ? (props) => 17 + 50 * props.level : 17,
      paddingRight:
        theme.direction === 'rtl' ? (props) => 17 + 50 * props.level : 17,

      [theme.breakpoints.up('xl')]: {
        paddingLeft:
          theme.direction === 'ltr' ? (props) => 24 + 50 * props.level : 24,
        paddingRight:
          theme.direction === 'rtl' ? (props) => 24 + 50 * props.level : 24,
      },

      '& .nav-item-text': {
        // fontFamily: Fonts.REGULAR,
        fontSize: 16,
        // color: '#FFF',

        [theme.breakpoints.up('xl')]: {
          marginTop: 4,
          marginBottom: 4,
          fontSize: 18,
        },
      },

      '& .nav-item-icon': {
        color: 'black',
      },

      '& .nav-item-icon-arrow': {
        // color: theme.palette.sidebar.textColor,
      },

      '& .MuiIconButton-root': {
        marginRight: -16,
      },

      '&.open, &:hover, &:focus': {
        '& .nav-item-text': {
          // fontFamily: Fonts.MEDIUM,
          // color: '#FFF',
        },

        '& .nav-item-icon': {
          // color: '#FFF',
        },

        '& .nav-item-icon-arrow': {
          // color: '#FFF',
        },
      },
    },

    navItemNevro: {
      height: 44,
      marginTop: 2,
      marginBottom: 2,
      width: 'calc(100% - 16px)',
      paddingLeft:
        theme.direction === 'ltr' ? (props) => 17 + 50 * props.level : 17,
      paddingRight:
        theme.direction === 'rtl' ? (props) => 17 + 50 * props.level : 17,

      [theme.breakpoints.up('xl')]: {
        paddingLeft:
          theme.direction === 'ltr' ? (props) => 24 + 50 * props.level : 24,
        paddingRight:
          theme.direction === 'rtl' ? (props) => 24 + 50 * props.level : 24,
      },

      '& .nav-item-text': {
        // fontFamily: Fonts.REGULAR,
        fontSize: 16,
        color: '#000',

        [theme.breakpoints.up('xl')]: {
          marginTop: 4,
          marginBottom: 4,
          fontSize: 18,
        },
      },

      '& .nav-item-icon': {
        color: '#000',
      },

      '& .nav-item-icon-arrow': {
        color: theme.palette.sidebar.textColor,
      },

      '& .MuiIconButton-root': {
        marginRight: -16,
      },

      '&.open, &:hover, &:focus': {
        '& .nav-item-text': {
          // fontFamily: Fonts.MEDIUM,
          color: '#000',
        },

        '& .nav-item-icon': {
          color: '#000',
        },

        '& .nav-item-icon-arrow': {
          color: '#000',
        },
      },
    },

    listItemText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    listIcon: {
      fontSize: 18,
      [theme.breakpoints.up('xl')]: {
        fontSize: 20,
      },
    },
  });

export default useStyles;
